import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { submitDataForm } from './actions'

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ submitDataForm }, dispatch)
}

export default function (InnerComponent) {
    @connect(null, mapDispatchToProps)
    class hocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocConnect
}
